// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ag-theme-quartz {
  --ag-header-background-color: #3B71CA; /* Header background */
}

::ng-deep .custom-table .ag-header-cell-text {
  color: rgb(255, 255, 255) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/table/hierarchical-grid/hierarchical-grid.component.scss"],"names":[],"mappings":"AAAA;EACI,qCAAA,EAAA,sBAAA;AACJ;;AAGE;EACE,oCAAA;AAAJ","sourcesContent":[".ag-theme-quartz {\n    --ag-header-background-color: #3B71CA; /* Header background */\n    //--ag-header-foreground-color: white;  /* Header text color */\n  }\n  \n  ::ng-deep .custom-table .ag-header-cell-text {\n    color: rgb(255, 255, 255) !important;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
